export default __webpack_public_path__ + "static/media/home.f5e04ef0.svg";